<script>

export default {
  name: 'pdf-create',

  data() {
    return {

    }
  },


  mounted() {
    console.log("mounted!!")
  },

  methods: {
    onPreview () {
      window.print()
    }
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pdf/PdfCreate.vue